module.exports = "/_next/static/images/wix-logo-51ec168acbf36ae88350f569c8bd230b.png";